import styled from 'styled-components';
import colors from '../../../theme/Colors';
import theme from 'styled-theming';

const dividerColor = theme('brand', {
    brenntag: colors.brenntag.dividerColor, 
    bcd: colors.bcd.dividerColor
});

export const SDivider = styled.hr`
    background-color: ${dividerColor};
    height: 1px;
    border: none;
`;